import { A } from '../actions/orders';
import update from 'immutability-helper';

const initialState = {
  getOrders: {
    isFetching: false,
    error: null,
  },
  getOrderById: {
    isFetching: false,
    error: null,
  },
  getOrdersStatusesLength: {
    isFetching: false,
    error: null,
  },
  getNearestOrders: {
    isFetching: false,
    error: null,
  },
  createOrder: {
    isFetching: false,
    error: null,
  },
  updateOrder: {
    isFetching: false,
    error: null,
  },
  cancelOrder: {
    isFetching: false,
    error: null,
  },
  getDeliveryInfo: {
    isFetching: false,
    error: null,
  },
  getWarehouses: {
    isFetching: false,
    error: null,
  },
  calcInsuranceSum: {
    isFetching: false,
    error: null,
  },
  refreshReserve: {
    isFetching: false,
    error: null,
  },
  refreshReserveBatch: {
    isFetching: false,
    error: null,
  },
  updatePaymentStatus: {
    isFetching: false,
    error: null,
  },
  getOrderHistory: {
    isFetching: false,
    error: null,
  },
  getOrdersExportTasks: {
    isFetching: false,
    error: null,
  },
  getOrdersReport: {
    isFetching: false,
    error: null,
  },
  getOrderSticker: {
    isFetching: false,
    error: null,
  },
  copyOrder: {
    isFetching: false,
    error: null,
  },
  updateOrderAddress: {
    isFetching: false,
    error: null,
  },
  uploadOrderFile: {
    isFetching: false,
    error: null,
  },
  deleteOrderFile: {
    isFetching: false,
    error: null,
  },
  editOrderFile: {
    isFetching: false,
    error: null,
  },
  uploadOrderPalletSticker: {
    isFetching: false,
    error: null,
  },
  deleteOrderPalletSticker: {
    isFetching: false,
    error: null,
  },
  uploadOrderPackingSticker: {
    isFetching: false,
    error: null,
  },
  emailRepeat: {
    isFetching: false,
    error: null,
  },
  updateOrderDelivery: {
    isFetching: false,
    error: null,
  },
  updateOrderDiscounts: {
    isFetching: false,
    error: null,
  },
  updateOrderComment: {
    isFetching: false,
    error: null,
  },
  getWorksheetFormTemplate: {
    isFetching: false,
    error: null,
  },
  getWorksheet: {
    isFetching: false,
    error: null,
  },
  updateWorksheet: {
    isFetching: false,
    error: null,
  },
  uploadFbmDocsFF: {
    isFetching: false,
    error: null,
  },
  uploadFbmStickersXls: {
    isFetching: false,
    error: null,
  },
  getFbmBarcodesXls: {
    isFetching: false,
    error: null,
  },
  getOrdersReturns: {
    isFetching: false,
    error: null,
  },
  postOrdersReturns: {
    isFetching: false,
    error: null,
  },
  deleteOrdersReturns: {
    isFetching: false,
    error: null,
  },
  getPackingOrder: {
    isFetching: false,
    error: null,
  },
  fbmDeliveryQrCode: {
    isFetching: false,
    error: null,
  },
  getDeliveryRawStatuses: {
    isFetching: false,
    error: null,
  },
  uploadDriverPermit: {
    isFetching: false,
    error: null,
  },
  getOzonInfo: {
    isFetching: false,
    error: null,
  },
  tags: null,
  deliveryInfo: null,
  warehouses: null,
  packingOrder: null,
  worksheetFormTemplate: null,
  ozonInfo: null,
  worksheetShipmentCode: null,
};

const items = (state = initialState, action) => {
  switch (action.type) {
    case A.REQUEST_GET_ORDERS:
      return update(state, {
        getOrders: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDERS:
      return update(state, {
        getOrders: {
          isFetching: { $set: false },
        },
        data: { $set: action.data },
      });

    case A.ERROR_GET_ORDERS:
      return update(state, {
        getOrders: {
          isFetching: { $set: true },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDER_BY_ID:
      return update(state, {
        getOrderById: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDER_BY_ID:
      return update(state, {
        getOrderById: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ORDER_BY_ID:
      return update(state, {
        getOrderById: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDERS_STATUSES_LENGTH:
      return update(state, {
        getOrdersStatusesLength: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDERS_STATUSES_LENGTH:
      return update(state, {
        getOrdersStatusesLength: {
          isFetching: { $set: false },
        },
        statusesLength: { $set: action.data },
      });

    case A.ERROR_GET_ORDERS_STATUSES_LENGTH:
      return update(state, {
        getOrdersStatusesLength: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_NEAREST_ORDERS:
      return update(state, {
        getNearestOrders: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_NEAREST_ORDERS:
      return update(state, {
        getNearestOrders: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_NEAREST_ORDERS:
      return update(state, {
        getNearestOrders: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_CREATE_ORDER:
      return update(state, {
        createOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_CREATE_ORDER:
      return update(state, {
        createOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_CREATE_ORDER:
      return update(state, {
        createOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER:
      return update(state, {
        updateOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_CONFIRM_ORDER:
      return update(state, {
        updateOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_CONFIRM_ORDER:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_CONFIRM_ORDER:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_CANCEL_ORDER:
      return update(state, {
        cancelOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_CANCEL_ORDER:
      return update(state, {
        cancelOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_CANCEL_ORDER:
      return update(state, {
        cancelOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER_ITEMS:
      return update(state, {
        updateOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER_ITEMS:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER_ITEMS:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER_CLIENT:
      return update(state, {
        updateOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER_CLIENT:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER_CLIENT:
      return update(state, {
        updateOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_DELIVERY_INFO:
      return update(state, {
        getDeliveryInfo: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DELIVERY_INFO:
      return update(state, {
        getDeliveryInfo: {
          isFetching: { $set: false },
        },
        deliveryInfo: { $set: action.data },
      });

    case A.ERROR_GET_DELIVERY_INFO:
      return update(state, {
        getDeliveryInfo: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_WAREHOUSES:
      return update(state, {
        getWarehouses: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_WAREHOUSES:
      return update(state, {
        getWarehouses: {
          isFetching: { $set: false },
        },
        warehouses: { $set: action.data },
      });

    case A.ERROR_GET_WAREHOUSES:
      return update(state, {
        getWarehouses: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_CALC_INSURANCE_SUM:
      return update(state, {
        calcInsuranceSum: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_CALC_INSURANCE_SUM:
      return update(state, {
        calcInsuranceSum: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_CALC_INSURANCE_SUM:
      return update(state, {
        calcInsuranceSum: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REFRESH_RESERVE:
      return update(state, {
        refreshReserve: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REFRESH_RESERVE:
      return update(state, {
        refreshReserve: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_REFRESH_RESERVE:
      return update(state, {
        refreshReserve: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_REFRESH_RESERVE_BATCH:
      return update(state, {
        refreshReserveBatch: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_REFRESH_RESERVE_BATCH:
      return update(state, {
        refreshReserveBatch: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_REFRESH_RESERVE_BATCH:
      return update(state, {
        refreshReserveBatch: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_PAYMENT_STATUS:
      return update(state, {
        updatePaymentStatus: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_PAYMENT_STATUS:
      return update(state, {
        updatePaymentStatus: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_PAYMENT_STATUS:
      return update(state, {
        updatePaymentStatus: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDER_HISTORY:
      return update(state, {
        getOrderHistory: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDER_HISTORY:
      return update(state, {
        getOrderHistory: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ORDER_HISTORY:
      return update(state, {
        getOrderHistory: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDERS_EXPORT_TASKS:
      return update(state, {
        getOrdersExportTasks: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDERS_EXPORT_TASKS:
      return update(state, {
        getOrdersExportTasks: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ORDERS_EXPORT_TASKS:
      return update(state, {
        getOrdersExportTasks: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDERS_REPORT:
      return update(state, {
        getOrdersReport: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDERS_REPORT:
      return update(state, {
        getOrdersReport: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ORDERS_REPORT:
      return update(state, {
        getOrdersReport: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDER_STICKER:
      return update(state, {
        getOrderSticker: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDER_STICKER:
      return update(state, {
        getOrderSticker: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ORDER_STICKER:
      return update(state, {
        getOrderSticker: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_COPY_ORDER:
      return update(state, {
        copyOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_COPY_ORDER:
      return update(state, {
        copyOrder: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_COPY_ORDER:
      return update(state, {
        copyOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER_ADDRESS:
      return update(state, {
        updateOrderAddress: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER_ADDRESS:
      return update(state, {
        updateOrderAddress: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER_ADDRESS:
      return update(state, {
        updateOrderAddress: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_TAGS:
      return update(state, {
        tags: { $set: action.data },
      });

    case A.REQUEST_UPLOAD_ORDER_FILE:
      return update(state, {
        uploadOrderFile: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPLOAD_ORDER_FILE:
      return update(state, {
        uploadOrderFile: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPLOAD_ORDER_FILE:
      return update(state, {
        uploadOrderFile: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_ORDER_FILE:
      return update(state, {
        deleteOrderFile: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_ORDER_FILE:
      return update(state, {
        deleteOrderFile: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_ORDER_FILE:
      return update(state, {
        deleteOrderFile: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPLOAD_FBM_STICKERS_PALLET_FILE:
      return update(state, {
        uploadOrderPalletSticker: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPLOAD_FBM_STICKERS_PALLET_FILE:
      return update(state, {
        uploadOrderPalletSticker: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPLOAD_FBM_STICKERS_PALLET_FILE:
      return update(state, {
        uploadOrderPalletSticker: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_FBM_STICKERS_PALLET_FILE:
      return update(state, {
        deleteOrderPalletSticker: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_FBM_STICKERS_PALLET_FILE:
      return update(state, {
        deleteOrderPalletSticker: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_FBM_STICKERS_PALLET_FILE:
      return update(state, {
        deleteOrderPalletSticker: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_EDIT_ORDER_FILE:
      return update(state, {
        editOrderFile: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_EDIT_ORDER_FILE:
      return update(state, {
        editOrderFile: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_EDIT_ORDER_FILE:
      return update(state, {
        editOrderFile: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPLOAD_FBM_STICKERS_PACKING_FILE:
      return update(state, {
        uploadOrderPackingSticker: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPLOAD_FBM_STICKERS_PACKING_FILE:
      return update(state, {
        uploadOrderPackingSticker: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPLOAD_FBM_STICKERS_PACKING_FILE:
      return update(state, {
        uploadOrderPackingSticker: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_EMAIL_REPEAT:
      return update(state, {
        emailRepeat: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_EMAIL_REPEAT:
      return update(state, {
        emailRepeat: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_EMAIL_REPEAT:
      return update(state, {
        emailRepeat: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER_DELIVERY:
      return update(state, {
        updateOrderDelivery: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER_DELIVERY:
      return update(state, {
        updateOrderDelivery: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER_DELIVERY:
      return update(state, {
        updateOrderDelivery: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER_DISCOUNTS:
      return update(state, {
        updateOrderDiscounts: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER_DISCOUNTS:
      return update(state, {
        updateOrderDiscounts: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER_DISCOUNTS:
      return update(state, {
        updateOrderDiscounts: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_ORDER_COMMENT:
      return update(state, {
        updateOrderComment: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_ORDER_COMMENT:
      return update(state, {
        updateOrderComment: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_ORDER_COMMENT:
      return update(state, {
        updateOrderComment: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_WORKSHEET_FORM_TEMPLATE:
      return update(state, {
        getWorksheetFormTemplate: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_WORKSHEET_FORM_TEMPLATE:
      return update(state, {
        getWorksheetFormTemplate: {
          isFetching: { $set: false },
        },
        worksheetFormTemplate: { $set: action.data },
      });

    case A.ERROR_GET_WORKSHEET_FORM_TEMPLATE:
      return update(state, {
        getWorksheetFormTemplate: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_WORKSHEET:
      return update(state, {
        getWorksheet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_WORKSHEET:
      return update(state, {
        getWorksheet: {
          isFetching: { $set: false },
        },
      });

    case A.RECEIVE_GET_WORKSHEET_SHIPMENT_CODE:
      return update(state, {
        worksheetShipmentCode: { $set: action.data },
      });

    case A.ERROR_GET_WORKSHEET:
      return update(state, {
        getWorksheet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPDATE_WORKSHEET:
      return update(state, {
        updateWorksheet: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPDATE_WORKSHEET:
      return update(state, {
        updateWorksheet: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPDATE_WORKSHEET:
      return update(state, {
        updateWorksheet: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPLOAD_FBM_DOCS_FF:
      return update(state, {
        uploadFbmDocsFF: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPLOAD_FBM_DOCS_FF:
      return update(state, {
        uploadFbmDocsFF: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPLOAD_FBM_DOCS_FF:
      return update(state, {
        uploadFbmDocsFF: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_UPLOAD_FBM_STICKERS_XLS:
      return update(state, {
        uploadFbmStickersXls: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_UPLOAD_FBM_STICKERS_XLS:
      return update(state, {
        uploadFbmStickersXls: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_UPLOAD_FBM_STICKERS_XLS:
      return update(state, {
        uploadFbmStickersXls: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_FBM_BARCODES_XLS:
      return update(state, {
        getFbmBarcodesXls: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_FBM_BARCODES_XLS:
      return update(state, {
        getFbmBarcodesXls: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_FBM_BARCODES_XLS:
      return update(state, {
        getFbmBarcodesXls: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_ORDER_EXCLUDE_CHANGE:
      return update(state, {
        updatePaymentStatus: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_ORDER_EXCLUDE_CHANGE:
      return update(state, {
        updatePaymentStatus: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_ORDER_EXCLUDE_CHANGE:
      return update(state, {
        updatePaymentStatus: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDERS_RETURNS:
      return update(state, {
        getOrdersReturns: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDERS_RETURNS:
      return update(state, {
        getOrdersReturns: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_ORDERS_RETURNS:
      return update(state, {
        getOrdersReturns: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_POST_ORDERS_RETURNS:
      return update(state, {
        postOrdersReturns: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_POST_ORDERS_RETURNS:
      return update(state, {
        postOrdersReturns: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_POST_ORDERS_RETURNS:
      return update(state, {
        postOrdersReturns: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_DELETE_ORDERS_RETURNS:
      return update(state, {
        deleteOrdersReturns: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_DELETE_ORDERS_RETURNS:
      return update(state, {
        deleteOrdersReturns: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_DELETE_ORDERS_RETURNS:
      return update(state, {
        deleteOrdersReturns: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_PACKING_ORDER:
      return update(state, {
        getPackingOrder: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_PACKING_ORDER:
      return update(state, {
        getPackingOrder: {
          isFetching: { $set: false },
        },
        packingOrder: { $set: action.data },
      });

    case A.ERROR_GET_PACKING_ORDER:
      return update(state, {
        getPackingOrder: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_POST_FBM_DELIVERY_QR_CODE:
      return update(state, {
        fbmDeliveryQrCode: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_POST_FBM_DELIVERY_QR_CODE:
      return update(state, {
        fbmDeliveryQrCode: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_POST_FBM_DELIVERY_QR_CODE:
      return update(state, {
        fbmDeliveryQrCode: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_DELIVERY_RAW_STATUSES:
      return update(state, {
        getDeliveryRawStatuses: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_DELIVERY_RAW_STATUSES:
      return update(state, {
        getDeliveryRawStatuses: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_GET_DELIVERY_RAW_STATUSES:
      return update(state, {
        getDeliveryRawStatuses: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_POST_DRIVER_PERMIT:
      return update(state, {
        uploadDriverPermit: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_POST_DRIVER_PERMIT:
      return update(state, {
        uploadDriverPermit: {
          isFetching: { $set: false },
        },
      });

    case A.ERROR_POST_DRIVER_PERMIT:
      return update(state, {
        uploadDriverPermit: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    case A.REQUEST_GET_ORDER_INFO:
      return update(state, {
        getOzonInfo: {
          isFetching: { $set: true },
          error: { $set: null },
        },
      });

    case A.RECEIVE_GET_ORDER_INFO:
      return update(state, {
        getOzonInfo: {
          isFetching: { $set: false },
        },
        ozonInfo: { $set: action.data },
      });

    case A.ERROR_GET_ORDER_INFO:
      return update(state, {
        getOzonInfo: {
          isFetching: { $set: false },
          error: { $set: action.err },
        },
      });

    default:
      return state;
  }
};

export default items;
